export enum RCS {
  //Values in meters
  EPSG_3857 = "EPSG:3857",

  //Values in degrees
  EPSG_4326 = "EPSG:4326",
}

export enum GritCoordinateType{
  Latitude,
  Longitude
}

export class GritCoordinates {

  type: GritCoordinateType;
  private _cardinal: string;
  private _degrees: number;
  private _minutes: number;
  private _seconds: number;
  private _value: number;

  constructor(type: GritCoordinateType, value: number = 0) {
    this.type = type;
    this.value = value;
  }

  valid(type: string): boolean {
    switch (type) {
      case "degrees":
        if (this.type == GritCoordinateType.Latitude){
          return this.degrees >= 0 && this.degrees <= 90;
        }else{
          return this.degrees >= 0 && this.degrees <= 180;
        }
      case "minutes":
        return this.minutes >= 0 && this.minutes <= 59;
      case "seconds":
        return this.seconds >= 0 && this.seconds <= 59.99;
      case "value":
        if (this.type == GritCoordinateType.Latitude){
          return this.degrees >= -90 && this.degrees <= 90;
        }else{
          return this.degrees >= -180 && this.degrees <= 180;
        }

    }
    return true
  }

  //#region GET/SET
  get cardinal() {
    return this._cardinal
  }

  set cardinal(value: string) {
    this._cardinal = value;
    this.updateValue();
  }

  get degrees() {
    return this._degrees
  }

  set degrees(value: number) {
    this._degrees = value;
    this.updateValue();
  }

  get minutes() {
    return this._minutes
  }

  set minutes(value: number) {
    this._minutes = value;
    this.updateValue();
  }

  get seconds() {
    return this._seconds
  }

  set seconds(value: number) {
    this._seconds = value;
    this.updateValue();
  }

  get value() {
    return Math.round(this._value * 100000) / 100000;
  }

  set value(value: number) {
    this._value = Math.round(value * 100000) / 100000;
    this.updateDMS();
  }
  //#endregion

  public toString = (): string => {
    return this.value.toString();
  }

  updateValue() {
    let value = (this.degrees + this.minutes / 60 + this.seconds / 3600)
    switch (this.type) {
      case GritCoordinateType.Latitude:
        value *= (this.cardinal === "S" ? -1 : 1);
        break;
      case GritCoordinateType.Longitude:
        value *= (this.cardinal === "W" ? -1 : 1);
        break;
    }
    this._value = Math.round(value * 100000) / 100000;
  }

  updateDMS() {
    let valueABS = Math.abs(this._value);
    this._degrees = Math.floor(valueABS);

    let minutes = (valueABS - this._degrees) * 60
    this._minutes = Math.floor(minutes);

    let seconds = (minutes - this._minutes) * 60;
    this._seconds = Math.floor(seconds);

    switch (this.type) {
      case GritCoordinateType.Latitude:
        this._cardinal = (this._value >= 0 ? "N" : "S");
        break;
      case GritCoordinateType.Longitude:
        this._cardinal = (this._value >= 0 ? "E" : "W");
        break;
    }
  }

  notamFormat(){
    let text = "";
    if (this.type == GritCoordinateType.Latitude){
      text += `${this._degrees.toFixed(0).padStart(2, "0")}`
    }else{
      text += `${this._degrees.toFixed(0).padStart(3, "0")}`
    }
    text += `${this._minutes.toFixed(0).padStart(2, "0")}${this.cardinal}`
    return text
  }
}
